import React, { useState, useEffect } from 'react'
import tw, { css, styled } from 'twin.macro'
import { Link, useStaticQuery, graphql } from 'gatsby'
import { BLOCKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import Button from './utils/button'
import filterLocale from './utils/filter-locale'
import Maytronics from './svg/maytronics'
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'
import { Client } from '../apollo/client'
// import { scrapingInstagramPosts } from 'gatsby-source-instagram/instagram'

const Sidebar = tw.div`flex flex-col w-full px-4 md:px-0 md:w-1/3 xl:w-1/4`
const FirstSidebarItem = tw.div`flex flex-col w-full mb-8`
const FirstItemTextContainer = tw.div`flex flex-col bg-blue-600 px-10 pt-12 pb-16 items-center`
const FirstItemttl = tw.h3`font-display text-2xl text-white mb-6 text-center font-bold`
const FirstItemText = tw.p`font-display text-sm text-white text-center`
const SecondSidebarItem = styled(FirstSidebarItem)`
	background: url('${({ bg }) => (bg ? bg : '')}');
	${tw`px-12 py-16 bg-no-repeat bg-cover bg-center`}
`
const SecondItemTextContainer = tw.div`flex flex-col items-center`
const SecondItemText = styled(FirstItemText)`
	${tw`mb-24`}
`
const RecentPostsContainer = styled.div`
	${tw`flex flex-col border border-solid border-gray-700 p-6 mb-6`}

	> a > div {
		${tw`py-3`}
	}
	> a:not(:last-of-type) > div {
		${tw`border-dashed border-b-2 border-gray-400`}
	}
`
const RecentPostsTitle = tw.h3`font-display text-2xl pb-2 border-solid border-b-2 border-gray-500 text-center font-bold mb-2`
const RecentPost = tw.div`flex flex-row`
const RecentPostImage = styled.div`
	${tw`flex w-6/12 pr-1 justify-center items-start`}
	img {
		max-height: 150px;
		${tw`hover:opacity-75`}
	}
`
const RecentPostDetails = tw.div`w-6/12 pl-1`
const PostTtl = tw.h4`font-display text-sm font-bold uppercase`
const PostDate = tw.p`font-display text-sm uppercase`
const FacebookContainer = styled.div`
	${tw`flex flex-col border border-solid border-gray-700 py-6 px-2 mb-6`}

	iframe {
		${tw`m-auto md:m-0`}
	}
`

const FbTitle = styled(RecentPostsTitle)``
const InstagramContainer = styled(FacebookContainer)``
const IgTitle = styled(RecentPostsTitle)``
const IgImageContainer = tw.div`flex flex-row flex-wrap w-full`
const IgItem = styled.div`
	${tw`w-1/3 p-1`}

	> a img {
		${tw`m-auto md:m-0`}
	}
`

const CategoriesContainer = styled(FacebookContainer)`
	${tw`mb-0`}
	> a p {
		${tw`py-2 hover:text-light-grayish-navy`}
	}
	> a:not(:last-of-type) p {
		${tw`border-dashed border-b-2 border-gray-400`}
	}
`
const CategoryTitle = styled(RecentPostsTitle)``
const CategoryItem = tw.p`font-display font-bold text-sm uppercase`
const CategoryCount = tw.span`font-normal`

const NewsSidebar = ({
	removeRecent,
	hide,
	hidefirst,
	checkedLocale,
	categoryLocale,
}) => {
	const locale = 'en-AU'
	const { inspiration, tellus, recent, categories } = useStaticQuery(graphql`
		query sideBarQuery {
			inspiration: allContentfulBanner(
				filter: { contentful_id: { eq: "4BEbcXosV8DHyo4HavR6P" } }
			) {
				edges {
					node {
						hook
						node_locale
						image {
							file {
								url
							}
							description
						}
						description {
							json
						}
					}
				}
			}
			tellus: allContentfulBanner(
				filter: { contentful_id: { eq: "4UZFMpa6emLOiNinFwTxry" } }
			) {
				edges {
					node {
						hook
						node_locale
						mainActionText
						mainActionUrl
						backgroundImage {
							file {
								url
							}
						}
						description {
							json
						}
					}
				}
			}
			recent: allContentfulPost(
				limit: 3
				skip: 5
				filter: {
					contentful_id: { ne: "4C5lPaagfRxOolLxODiDen" }
					node_locale: { eq: "en-AU" }
				}
				sort: { fields: dateAndTime, order: DESC }
			) {
				edges {
					node {
						category
						slug
						seoTitle
						seoDescription
						node_locale
						dateAndTime(formatString: "DD MMMM, YYYY")
						image {
							file {
								url
							}
							description
						}
					}
				}
			}
			categories: allContentfulPost(
				filter: {
					slug: { ne: null }
					category: { ne: "Mineral Swim" }
					node_locale: { in: ["en-AU", "en-NZ", "en-ZA"] }
				}
			) {
				group(field: category) {
					fieldValue
					edges {
						node {
							seoTitle
							category
							node_locale
							countryAvailability
						}
					}
				}
			}
		}
	`)
	const inspirationByLocale = filterLocale(inspiration.edges, locale)
	const tellUsByLocale = filterLocale(tellus.edges, locale)
	// const recentByLocale = filterLocale(recent.edges, locale)
	const getNode = filteredArray => {
		return filteredArray.map((item, i) => {
			return item.node
		})
	}

	const filterCategory = (category, locale) => {
		return category
			.map(x => {
				const availability = x.node.countryAvailability
				const alterLocale = locale.slice(3)
				const isActiveInLocale = availability.indexOf(alterLocale)
				if (x.node.node_locale === locale) {
					if (isActiveInLocale >= 0) {
						return x
					}
				}
			})
			.filter(x => {
				return x != undefined
			})
	}
	const grp = [...categories.group]
	const category = grp.map(cat => {
		return {
			field: cat.fieldValue,
			count: filterCategory(cat.edges, categoryLocale).length,
		}
	})
	const [{ hook, image, description }] = getNode(inspirationByLocale)
	const [
		{
			hook: tellusHook,
			backgroundImage,
			description: tellusDescription,
			mainActionText,
			mainActionUrl,
		},
	] = getNode(tellUsByLocale)

	// const [...posts] = getNode(recentByLocale)
	const options = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<FirstItemText>{children}</FirstItemText>
			),
		},
	}
	const optiontwo = {
		renderNode: {
			[BLOCKS.PARAGRAPH]: (node, children) => (
				<SecondItemText>{children}</SecondItemText>
			),
		},
	}

	// const [insta, setInsta] = useState([])
	// const gramOption = {
	// 	username: `mydolphinaus`,
	// }

	// async function getInstagramPosts(options) {
	// 	return await scrapingInstagramPosts(options)
	// }

	// useEffect(() => {
	// 	if ( insta.length === 0 ) {
	// 		getInstagramPosts(gramOption).then(data => {
	// 			const x = data.slice(0,9)
	// 			setInsta(x)
	// 		})
	// 	}
	// }, [insta])

	const APOLLO_RECENT = gql`
		query Recent(
			$skip: Int!
			$limit: Int!
			$node_locale: String!
			$country: [String]!
		) {
			postCollection(
				limit: $limit
				skip: $skip
				where: { countryAvailability_contains_some: $country }
				locale: $node_locale
				order: dateAndTime_DESC
			) {
				items {
					seoTitle
					slug
					category
					dateAndTime(locale: $node_locale)
					countryAvailability
					seoDescription
					tag
					image {
						url
						description
					}
				}
				total
			}
		}
	`

	const countryLocale = categoryLocale.slice(3)
	const { loading, error, data: apolloData } = useQuery(APOLLO_RECENT, {
		variables: {
			skip: 0,
			limit: 3,
			node_locale: categoryLocale,
			country: [countryLocale],
		},
		client: Client,
	})

	return (
		<Sidebar>
			{hidefirst ? (
				''
			) : (
				<FirstSidebarItem>
				<CategoriesContainer>
					<CategoryTitle>Categories</CategoryTitle>
					{category.map((cat, i) => {
						const categoryLink = cat.field
							.toLowerCase()
							.split(' ')
							.join('-')
						return cat.count >= 1 ? (
							<Link to={`${checkedLocale}/blog/${categoryLink}/`} key={i}>
								<CategoryItem>
									{cat.field}
									<CategoryCount>{` (${cat.count})`}</CategoryCount>
								</CategoryItem>
							</Link>
						) : (
							<></>
						)
					})}
				</CategoriesContainer>
			
				</FirstSidebarItem>
			)}

			<SecondSidebarItem
				bg={
					backgroundImage.file.url +
					'?w=309&h=372&fit=fill&f=bottom&fm=webp&q=60'
				}
			>
				<SecondItemTextContainer>
					<FirstItemttl>{tellusHook}</FirstItemttl>
					{documentToReactComponents(tellusDescription.json, optiontwo)}
					<Button
						color="grey-blue-bis"
						fill={true}
						sitePadding="2rem"
						name={mainActionText}
						link={`${mainActionUrl}`}
					/>
				</SecondItemTextContainer>
			</SecondSidebarItem>

			{removeRecent ? null : (
				<RecentPostsContainer>
					<RecentPostsTitle>Recent Posts</RecentPostsTitle>

					{apolloData != undefined
						? apolloData.postCollection.items.map((post, i) => {
							const options = {
								year: 'numeric',
								month: 'long',
								day: 'numeric',
							}
							const newDate = new Date(post.dateAndTime)
							if(post.category !== "Mineral Swim"){
								return (
									<Link to={`${checkedLocale}/${post.slug}`} key={i}>
										<RecentPost>
											<RecentPostImage>
												{post.image ? (
													<img
														src={
															post.image.url +
															'?w=126&h=84&fit=fill&f=bottom&fm=webp&q=60'
														}
														alt={post.image.description}
														loading="lazy"
													/>
												) : (
													<Maytronics width="100%" />
												)}
											</RecentPostImage>
											<RecentPostDetails>
												<PostTtl>{post.seoTitle}</PostTtl>
												<PostDate>
													{newDate.toLocaleDateString(categoryLocale, options)}
												</PostDate>
											</RecentPostDetails>
										</RecentPost>
									</Link>
								)
							}
						})
				: ''}
				</RecentPostsContainer>
			)}

			{/* <FacebookContainer>
				<FbTitle>Facebook</FbTitle>
				<iframe
					src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FMaytronicsAustralia&tabs=timeline&width=270&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
					width="auto"
					height="300"
					css={{ border: 'none', overflow: 'hidden' }}
					scrolling="no"
					frameBorder="0"
					allowTransparency="true"
					allow="encrypted-media"
					loading="lazy"
					title="facebook page embed"
				></iframe>
			</FacebookContainer> */}

			{/* <InstagramContainer>
				<IgTitle>
					<a href="https://www.instagram.com/mydolphinaus/" target="_blank">
						Instagram
					</a>
				</IgTitle>
				<IgImageContainer>
					{insta.length != 0 ? (insta.map((gram, i) => {
						return (
							<IgItem key={i}>
								<a href={gram.thumbnail_src} target="_blank">
									<img src={gram.thumbnail_resources[0].src} alt="" />
								</a>
							</IgItem>
						)
					})) : ''}
				</IgImageContainer>
			</InstagramContainer> */}

			
		</Sidebar>
	)
}

export default NewsSidebar
